// extracted by mini-css-extract-plugin
export default {"fba-div":"FbaFee_fba-div__vx9Yi","fba-div2":"FbaFee_fba-div2__3gTnL","small":"FbaFee_small__caXV0","acc-collpse":"FbaFee_acc-collpse__+4mSp"};